import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { UtilsService } from '../utils/utils.service';

@Injectable({
  providedIn: 'root'
})
export class AuthorizePaymentService {

	constructor(private http: HttpClient, private utils: UtilsService) {}

	create_customer(payload){
		const url = `${environment.api}payment/create_customer`;
		const formData: any = this.utils.jsonToFormData(payload);
		return this.http.post(url, formData);
	}

	charge_customer(payload){
		const url = `${environment.api}payment/charge_customer`;
		const formData: any = this.utils.jsonToFormData(payload);
		return this.http.post(url, formData);
	}

	get_all_approved_not_paid( ){
		const url = `${environment.api}payment/get_all_approved_no_paid`;
		return this.http.get(url);
	}

}
